<div class="tooltip-container"
     (mouseenter)="onMouseEnter($event)"
     (mouseleave)="onMouseLeave()">

  <!-- Info Icon -->
  <svg #tooltipIcon class="info-icon" viewBox="0 0 24 24">
    <circle class="circle" cx="12" cy="12" r="10" fill="currentColor"/>
    <text x="12" y="16" text-anchor="middle" font-size="12" font-weight="bold" fill="white">i</text>
  </svg>

  <!-- Tooltip Content -->
  <div #tooltipContent
       class="tooltip-content"
       [class.show]="isHovered"
       [innerHTML]="content()">
  </div>
</div>